// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--rovo-expansion/rovo-chat-input-full-page';

import { MessageFrontend as createMessageFrontendRovoExtensionInstallCtaRovoChatInput } from '@post-office/browser--rovo-expansion/rovo-extension-install-cta-rovo-chat-input/placements/in-app-v2/rovo-chat-input-full-page';
import { MessageFrontend as createMessageFrontendRovoChatInputBanner3PConnectorNudge } from '@post-office/browser--rovo-chat/rovo-chat-input-banner-3p-connector-nudge/placements/in-app-v2/rovo-chat-input-full-page';
import { MessageFrontend as createMessageFrontendRovoMobileDeepResearchCtaRovoChatInput } from '@post-office/browser--rovo-mobile/rovo-mobile-deep-research-cta-rovo-chat-input/placements/in-app-v2/rovo-chat-input-full-page';
import { MessageFrontend as createMessageFrontendRovoChatLongRunningTaskFullpageBanner } from '@post-office/browser--rovo-chat/rovo-chat-long-running-task-fullpage-banner/placements/in-app-v2/rovo-chat-input-full-page';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type AppProps } from '@post-office/browser--rovo-expansion/common/types';
import { type ComponentType } from 'react';

const messageFrontends = [
	createMessageFrontendRovoExtensionInstallCtaRovoChatInput({
		messageTemplateId: 'rovo-extension-install-cta-rovo-chat-input',
	}),
	createMessageFrontendRovoChatInputBanner3PConnectorNudge({
		messageTemplateId: 'rovo-chat-input-banner-3p-connector-nudge',
	}),
	createMessageFrontendRovoMobileDeepResearchCtaRovoChatInput({
		messageTemplateId: 'rovo-mobile-deep-research-cta-rovo-chat-input',
	}),
	createMessageFrontendRovoChatLongRunningTaskFullpageBanner({
		messageTemplateId: 'rovo-chat-long-running-task-fullpage-banner',
	}),
];

export const RawPlacement: PlacementRendererStage<AppProps> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

export const Placement: ComponentType<
	Omit<AppProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<AppProps> = RawPlacement;
